"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customDateWindow = exports.comparisonInput = exports.inputSection = void 0;
var widgets_1 = require("@tableau/widgets");
var typestyle_1 = require("typestyle");
var inputSectionStyle = {
    marginBottom: widgets_1.TabStyles.Spacing.LargeSpace + "px",
    width: '100%',
    $nest: {
        'input, textarea': {
            width: '100%',
            resize: 'none',
        },
        label: {
            fontWeight: 'bold',
        },
        /* Chrome, Safari, Edge, Opera */
        'input::-webkit-outer-spin-button, input::-webkit-inner-spin-button': {
            '-webkit-appearance': 'none',
            margin: 0,
        },
        /* Firefox */
        'input[type=number]': {
            '-moz-appearance': 'textfield',
        },
    },
};
var comparisonInputStyle = {
    marginBottom: '3px',
};
exports.inputSection = (0, typestyle_1.style)(inputSectionStyle);
exports.comparisonInput = (0, typestyle_1.style)(inputSectionStyle, comparisonInputStyle);
exports.customDateWindow = (0, typestyle_1.style)({
    marginBottom: widgets_1.TabStyles.Spacing.LargeSpace + "px",
    fontWeight: 'normal',
    $nest: {
        '>label>div': {
            overflow: 'visible',
        },
    },
});
//# sourceMappingURL=configurationStyles.js.map